if (!customElements.get('cart-consent')) {
  class CartConsent extends HTMLElement {
    connectedCallback() {
      this._checkbox = this.querySelector('.cart-consent__checkbox');
      if (!this._checkbox) return;

      this._hint = this.querySelector('.cart-consent__hint');
      this._abortController = new AbortController();
      const { signal } = this._abortController;

      this._checkbox.addEventListener('change', this._onChange.bind(this), { signal });
      // The theme never disables the checkout button. This capture-phase listener on document runs
      // before any handler on the button itself and stops the click while the box is unticked. An
      // app (Parcely) binds its own target-phase handler there and may disable or re-enable the
      // button for its own reason (no locker chosen), which the theme does not read.
      document.addEventListener('click', this._onDocumentClick.bind(this), { capture: true, signal });
    }

    disconnectedCallback() {
      this._abortController?.abort();
    }

    _scope() {
      return (
        this.closest('.cart__footer') ||
        this.closest('#CartDrawer') ||
        document
      );
    }

    _showHint(show) {
      this._hint?.classList.toggle('visually-hidden', !show);
      if (show) {
        this._checkbox.setAttribute('aria-invalid', 'true');
      } else {
        this._checkbox.removeAttribute('aria-invalid');
      }
    }

    _onDocumentClick(event) {
      const btn = event.target.closest?.('#checkout, #CartDrawer-Checkout');
      if (!btn || !this._scope().contains(btn) || this._checkbox.checked) return;

      // A synthetic click from an implicit form submission (Enter in a quantity field) is cancelled
      // without the hint; keyboard activation of the focused button keeps activeElement === btn.
      if (event.detail === 0 && document.activeElement !== btn) {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      this._showHint(true);
      this._checkbox.focus();
    }

    _onChange() {
      const checked = this._checkbox.checked;
      if (checked) this._showHint(false);

      this._fetchController?.abort();
      this._fetchController = new AbortController();

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Terms & Privacy accepted': checked
              ? 'yes — ' + new Date().toISOString()
              : '',
          },
        }),
        signal: this._fetchController.signal,
      })
        .then((res) => {
          if (!res.ok) throw new Error('cart-consent: update failed ' + res.status);
        })
        .catch((err) => {
          if (err.name !== 'AbortError') console.error(err);
        });
    }
  }

  customElements.define('cart-consent', CartConsent);
}
